import { SVGFC } from '@repo/toolkit/types'

const MessageIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4C7.589 4 4 7.589 4 12C4 13.538 4.431 15.015 5.248 16.288L4.036 19.314C3.962 19.5 4.005 19.712 4.147 19.854C4.242 19.949 4.37 20 4.5 20C4.563 20 4.625 19.988 4.686 19.964L7.712 18.752C8.985 19.569 10.462 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4ZM12 19C10.574 19 9.209 18.578 8.054 17.779C7.97 17.72 7.87 17.69 7.77 17.69C7.707 17.69 7.644 17.702 7.584 17.726L5.398 18.602L6.274 16.416C6.336 16.26 6.316 16.083 6.221 15.946C5.422 14.791 5 13.426 5 12C5 8.14 8.14 5 12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19Z"
        fill={color}
      />
    </svg>
  )
}

export default MessageIcon
